export default __webpack_public_path__ + "static/media/slide5.97a6ab3e.jpg";